import { createSlice, current } from '@reduxjs/toolkit'

function filterProjectGenerate(list, id_tab) {
    /*
            id - ИД проекта
            name - Название проекта
            count - Кол-во элементов в проекте   
    */
    var filter_list = [];

    list.filter(a => a.ID_Project != null).map(item => {
        if (filter_list.filter(a => a.id === item.ID_Project).length === 0) {
            filter_list.push({ id: item.ID_Project, name: item.Name_Project, count: list.filter(a => a.ID_Project === item.ID_Project).length, id_tab: id_tab })
        }
    })
    return filter_list;
}
//Определит id_tab задачи
function taskTabGet(model) {
    var id_tab = null;

    //Черновик
    if (model.ID_Status === 0) {
        id_tab = 0;
    }
    //Активная
    if (model.ID_Status === 1) {
        //Если задача будущая
        if (model.Future === true) {
            id_tab = 3;
        }
        //Если задача активная
        else {
            //Наблюдатель
            if (model.ID_Action === 1) {
                id_tab = 2;
            }
            //Исполнитель
            if (model.ID_Action === 2) {
                id_tab = 1;
            }
        }
    }
    //Выполнена
    if (model.Completed === true) {
        id_tab = 5;
    }

    return id_tab;
}

const taskList = createSlice({
    name: 'taskList',
    initialState: {
        list: [],//Список задач
        listLoaded: [],//Флаг состояния загрузки задач

        listCheckList: [],//Список чек-листов
        listUser: [],//Список пользователей задач
        listLabel: [],//Список меток задач

        //filterUser: [],//Фильр пользователей  УДАЛИТЬ
        filterProject: [],//Фильр проектов
        //filterLabel: [],//Фильтр меток      УДАЛИТЬ
    },
    reducers: {
        //id_tab: 0-Черновик; 1-Исполнитель; 2-Наблюдатель; 3-Будущие; 4-Все; 5-Выполненные;

        loadList(state, action) {
            const id_tab = action.payload.id_tab;
            const list = action.payload.list;

            state.list = [...state.list.filter(a => a.id_tab !== id_tab), ...list.map((item) => { return { ...item, filter_project: 0, filter_label: 0, filter_user: 0, id_tab: id_tab } })].sort((a, b) => a.ID - b.ID);
            state.listLoaded = [...state.listLoaded.filter(a => a.id_tab !== id_tab), { id_tab: id_tab }];
            state.filterProject = [...state.filterProject.filter(a => a.id_tab !== id_tab), ...filterProjectGenerate(list, id_tab)];
        },
        loadUserList(state, action) {
            const id_tab = action.payload.id_tab;

            const list = action.payload.list.map(item => {
                return { ...item, id_tab: id_tab }
            })

            state.listUser = [...state.listUser.filter(a => a.id_tab !== id_tab), ...list];
        },
        loadLabelList(state, action) {
            const id_tab = action.payload.id_tab;

            const list = action.payload.list.map(item => {
                return { ...item, id_tab: id_tab }
            })

            state.listLabel = [...state.listLabel.filter(a => a.id_tab !== id_tab), ...list];
        },
        loadCheckList(state, action) {
            const id_tab = action.payload.id_tab;

            const list = action.payload.list.map(item => {
                return { ...item, id_tab: id_tab }
            })

            state.listCheckList = [...state.listCheckList.filter(a => a.id_tab !== id_tab), ...list];
        },

        filterLabel(state, action) {
            const id_tab = action.payload.id_tab;
            const id_label = action.payload.id_label;

            if (id_label === -1) {
                state.list = state.list.map((item) => {
                    if (item.id_tab === id_tab) {
                        return { ...item, filter_label: 0 }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
            else {
                state.list = state.list.map((item) => {
                    if (item.id_tab === id_tab) {
                        return { ...item, filter_label: state.listLabel.filter(a => a.id_tab === id_tab & a.ID_Label === id_label & a.ID_Item === item.ID).length == 0 ? 1 : 0 }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
        },
        filterUser(state, action) {
            const id_tab = action.payload.id_tab;//0-Черновик; 1-Исполнитель; 2-Наблюдатель; 3-Будущие; 4-Все; 5-Выполненные;
            const id_user = action.payload.id_user;

            //Очишаем предыдущие значения
            state.list = state.list.map((item) => {
                if (item.id_tab === id_tab) {
                    return { ...item, filter_user: 0 }
                }
                else {
                    return { ...item }
                }
            })

            //Устанавливаем/снимаем фильтр
            if (id_user === -1) {
                state.list = state.list.map((item) => {
                    if (item.id_tab === id_tab & item.ID_User !== id_user) {
                        return { ...item, filter_user: 0 }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
            else {
                state.list = state.list.map((item) => {
                    if (item.id_tab === id_tab & item.ID_User !== id_user) {
                        return { ...item, filter_user: 1 }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
        },
        filterProject(state, action) {
            const id_tab = action.payload.id_tab;//0-Черновик; 1-Исполнитель; 2-Наблюдатель; 3-Будущие; 4-Все; 5-Выполненные;
            const id_project = action.payload.id_project;

            //Очишаем предыдущие значения
            state.list = state.list.map((item) => {
                if (item.id_tab === id_tab) {
                    return { ...item, filter_project: 0 }
                }
                else {
                    return { ...item }
                }
            })

            //Устанавливаем/снимаем фильтр
            if (id_project === -1) {
                state.list = state.list.map((item) => {
                    if (item.id_tab === id_tab & item.ID_Project !== id_project) {
                        return { ...item, filter_project: 0 }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
            else {
                state.list = state.list.map((item) => {
                    if (item.id_tab === id_tab & item.ID_Project !== id_project) {
                        return { ...item, filter_project: 1 }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
        },

        update(state, action) {
            const model = action.payload.model;
            const calendar = action.payload.calendar;

            const id_tab = calendar === true ? -1 : taskTabGet(model);

            //Обновляем задачи
            state.list = [...state.list.filter(a => a.ID !== model.ID), { ...model, filter_project: 0, filter_label: 0, filter_user: 0, id_tab: id_tab }].sort((a, b) => a.ID - b.ID);

            //Обновляем фильтр проектов
            if (model.ID_Project != null) {
                state.filterProject = [...state.filterProject.filter(a => a.id_tab !== id_tab), ...filterProjectGenerate(state.list.filter(a => a.id_tab === id_tab), id_tab)];
            }
        },
        updateLabel(state, action) {
            const data = action.payload.data;
            const id_task = action.payload.id_task;
            const id_tab = state.list.filter(a => a.ID === id_task)[0].id_tab;
            state.listLabel = [...state.listLabel.filter(a => a.ID_Item !== id_task), ...data.map((item) => { return { ...item, id_tab: id_tab } })]
        },
        updateUser(state, action) {
            const task = action.payload.task;
            const users = action.payload.users;
            const id_tab = taskTabGet(task);

            //Обновляем задачу, т.к. может оказаться в другой вкладки           
            state.list = [...state.list.filter(a => a.ID !== task.ID), { ...task, filter_project: 0, filter_label: 0, filter_user: 0, id_tab: id_tab }].sort((a, b) => a.ID - b.ID);

            //Обновляем список ответственных задачи
            state.listUser = [...state.listUser.filter(a => a.ID_Task !== task.ID), ...users.map((item) => { return { ...item, id_tab: id_tab } })]
        },
        updateCheckList(state, action) {
            const data = action.payload.data;
            const id_task = action.payload.id_task;
            const id_tab = current(state.list).filter(a => a.ID === id_task)[0].id_tab;

            state.listCheckList = [...state.listCheckList.filter(a => a.ID_Item !== id_task), ...data.map((item) => { return { ...item, id_tab: id_tab } })];
        },

        remove(state, action) {
            const id = action.payload.id;
            const id_tab = state.list.filter(a => a.ID === id)[0].id_tab;

            state.list = [...state.list.filter(a => a.ID !== id)];
            state.filterProject = [...state.filterProject.filter(a => a.id_tab !== id_tab), ...filterProjectGenerate(state.list.filter(a => a.id_tab === id_tab), id_tab)];
        },
        cleanFilter(state, action) {
            const id_tab = action.payload.id_tab;
            state.filterLabel = [...state.filterLabel.filter(a => a.id_tab !== id_tab)];
            state.filterProject = [...state.filterProject.filter(a => a.id_tab !== id_tab)];
            state.filterUser = [...state.filterUser.filter(a => a.id_tab !== id_tab)];
        },
        userView(state, action) {
            const id_task = action.payload.id_task;
            const id_user = action.payload.id_user;

            state.list = state.list.map(item => {
                if (item.ID === id_task) {
                    return { ...item, Viewed: true }
                }
                else {
                    return { ...item }
                }
            })

            state.listUser = state.listUser.map(item => {
                if (item.ID_Task === id_task & item.ID_User === id_user) {
                    return { ...item, Viewed: true }
                }
                else {
                    return { ...item }
                }
            })
        },


    }
})
export const { loadList, loadLabelList, loadUserList, loadCheckList, update, updateLabel, updateCheckList, updateUser, remove, filterLabel, filterProject, filterUser, cleanFilter, userView } = taskList.actions
export default taskList.reducer